import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { WorkFlowReportService } from '../../../../../services/workflowreport.service';
import { DialogImageComponent } from '../../../dialog-image/dialog-image.component';


@Component({
  selector: 'wdm-container-ocr-report',
  templateUrl: 'container-ocr-report.component.html',
  styleUrls: ['container-ocr-report.component.scss']
})

export class ContainerOcrReportComponent implements OnInit {

  @Input() stepinfo: any;
  result: Result = null;
  container: ContainerCodes;

  constructor(public workFlowReportService: WorkFlowReportService, public dialog: MatDialog) {

  }

  ngOnInit() {
    const result = JSON.parse(this.stepinfo.result);
    this.container = result.containerCodes;

  }

  openImage(imageURL: string) {
    const dialogImage = this.dialog.open(DialogImageComponent, {
      width: '90%',
      data: {
        img: imageURL,
      }
    });
  }
}

interface Result {
  containerCodes: ContainerCodes;
}


interface ContainerCodes {
  CheckDigit: Number;
  CompanyCode: string;
  ContainerNumber: Number;
  ContainerType: string;
  IsValid: boolean;
  PhotoFileName: string;
}

